


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master edit5] Init';
export const DESTROY_SCREEN = '[Master edit5] Destroy';

export const INIT_STATE = '[Master edit5] Init State';
export const INIT_VALUE = '[Master edit5] Init Value';
export const INIT_VALUE_SUCCESS = '[Master edit5] Init Value Success';
export const INIT_VALUE_FAIL = '[Master edit5] Init Value Fail';

export const UPDATE_DATA = "[Master edit5] Update Data";




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);






export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);





export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

